import { FetchUtil } from "../util/FetchUtil";
import { HealioErrorModal } from "../components/healioGlobal/HealioErrorModal"
import { WyanokeUtil } from "../util/WyanokeUtil";
import { IQBankServiceEndpoint } from "../models/QBank/IQBankServiceEndpoint";
import { Cookie } from "../util/CookieUtil";

export class QBankService {
  constructor(private readonly _endpoint: IQBankServiceEndpoint) { }

  public async completeQuiz(
    quizId : string
  ):Promise<boolean> {
    const endpoint = this._endpoint.completeQuiz;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }
    let anonymousId = Cookie.getCookie("anonid");
    const profile = await WyanokeUtil.loadUserProfile(true, false);
    if (!profile && !anonymousId) {
      return false;
    }

    const contactId = profile?.contactid || null;
    const values = {
        contactid: contactId,
        anonymousid: anonymousId || null,
        quizid: quizId,
        timeremaining: -1,
        status: 1
    };

    const raw = await FetchUtil.sendMessage(
        endpoint,
        values,
        "default",
        false
      );

      if (typeof raw !== "object") {
        const msg = "Unexpected response from server";
        console.error(msg, raw);
        HealioErrorModal.triggerHealioErrorModalEvent();
        return false;
      }

      return true;
  }
  public async saveAnswer(
    quizId: string,
    questionItemId: string,
    answerItemId: string,
    status: Number
  ): Promise<boolean> {
    const endpoint = this._endpoint.saveAnswer;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }
    let anonymousId = Cookie.getCookie("anonid");
    const profile = await WyanokeUtil.loadUserProfile(true, false);
    if (!profile && !anonymousId) {
      return false;
    }

    const contactId = profile?.contactid || null;
    const values = {
        contactid: contactId,
        anonymousid: anonymousId || null,
        quizid: quizId,
        questionitemid: questionItemId ,
        AnswerItemId: answerItemId,
        Status: status
    };

    const raw = await FetchUtil.sendMessage(
      endpoint,
      values,
      "default",
      false
    );

    if (typeof raw !== "object") {
      const msg = "Unexpected response from server";
      console.error(msg, raw);
      HealioErrorModal.triggerHealioErrorModalEvent();
      return false;
    }

    return true;
  }
}
